import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';

var _excluded = ["children", "height"];
var Overlay = function Overlay(_ref) {
  var children = _ref.children,
    height = _ref.height,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
    backgroundColor: "base.overlay.strong",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    width: "100vw",
    height: height || '100%',
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }), children);
};
Overlay.displayName = 'Overlay';

export { Overlay };
//# sourceMappingURL=Overlay.js.map
